module.exports = {
  uiComponentsVersion: '0.0.210',
  mapsHereDotComApiKey: 'BxpKXlRo9fD5czrJQk0qK6ZljwkIoKbTJnNOxz3tEY8' // This value is a placeholder and should be replaced with the actual API key during the build process, as shown in jenkins-shared-libs/vars/ui.groovy
}
